var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 59.5V84.5C18.75 87.9375 21.5625 90.75 25 90.75H43.75L64.3125 111.313C68.25 115.25 75 112.438 75 106.875V37.0625C75 31.5 68.25 28.6875 64.3125 32.625L43.75 53.25H25C21.5625 53.25 18.75 56.0625 18.75 59.5ZM103.125 72C103.125 60.9375 96.75 51.4375 87.5 46.8125V97.125C96.75 92.5625 103.125 83.0625 103.125 72ZM87.5 24.8125V26.0625C87.5 28.4375 89.0625 30.5 91.25 31.375C107.375 37.8125 118.75 53.625 118.75 72C118.75 90.375 107.375 106.188 91.25 112.625C89 113.5 87.5 115.563 87.5 117.938V119.188C87.5 123.125 91.4375 125.875 95.0625 124.5C116.25 116.438 131.25 96 131.25 72C131.25 48 116.25 27.5625 95.0625 19.5C91.4375 18.0625 87.5 20.875 87.5 24.8125Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.62090f33.svg";
export { ForwardRef as ReactComponent };